import { howItWorks } from '@/mocks/features';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Simple Process
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            How Vigorbuy Spreadsheet Works
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Getting started is easy. Follow these four simple steps to discover products you will love.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {howItWorks.map((step) => (
            <div key={step.step} className="relative text-center p-5 md:p-6">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 relative z-10">
                <span className="font-heading text-xl font-bold">{step.step}</span>
              </div>
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                <i className={`${step.icon} text-base`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}